export enum AdvAssetsAuthResult {
  'REJECT' = 2,
  'AUTHORISE' = 3
}

export enum AdvAssetsAuthStatus {
  'ADD' = 1,
  'EDIT' = 2
}

export enum PermissionType {
  'SendRequest' = 1,
  'Rejected' = 2,
  'Authorized' = 3,
  'Notified' = 4
}
export interface AdvAuthorizeRecordInfo {
  partnerId: number;
  partnerName: string;
  partnerEmail: string;
  permissionType: PermissionType;
  operationTime: number; // s
}
